<template>
  <li class="ah-list__item">
    <slot />
  </li>
</template>
<script>
  export default {
    name: 'AhListItem',
  };
</script>
